import { DataGetter, trackView } from '@rea-argonaut/analytics';
import { getCampaignData, getPageData } from '@realestate.com.au/iglu-data';
import { getPcaUserData } from '../../helpers/getPcaUserData';
import { User } from '@property.com.au/argonaut';
import { deepOmitTypeName } from '../../analytics/helpers/deepOmitTypeName';
import { objectRemoveEmptyDeep } from '../../analytics/helpers/objectRemoveEmptyDeep';

export interface PropertyPageTracking {
  pageData: PropertyPageTrackingDataPageData;
  useUserContext: boolean;
  propertyContext?: PropertyPageTrackingDataPropertyContext;
  agentsContext?: PropertyPageTrackingDataAgentsContext | null;
}

interface PropertyPageTrackingDataPageData {
  pageType: string;
  siteSection: string;
  site: string;
  siteSubSection: string;
}

interface PropertyPageTrackingDataPropertyContext {
  schema: string;
  data: {
    property_id: string;
    listing_id?: string | null;
    active_rea_listing?: string | null;
    country?: string | null;
    state?: string | null;
    suburb?: string | null;
    postcode?: string | null;
    bedrooms?: number | null;
    bathrooms?: number | null;
    car_spaces?: number | null;
    year_built?: number | null;
    property_type?: string | null;
    land_size_sq_metres?: number | null;
    floor_area?: string | null;
    avm_estimated_value?: number | null;
    avm_low_range?: number | null;
    avm_high_range?: number | null;
    avm_confidence?: string | null;
    avm_last_updated_date?: string | null;
    tracked_relationship_type?: string | null;
    property_report?: string | null;
  };
}

interface PropertyPageTrackingDataPropertyContextV2 {
  schema: string;
  data: {
    property_id: string;
    listing_id?: string | null;
    active_rea_listing?: string | null;
    country?: string | null;
    state?: string | null;
    suburb?: string | null;
    postcode?: string | null;
    bedrooms?: number | null;
    bathrooms?: number | null;
    car_spaces?: number | null;
    year_built?: number | null;
    property_type?: string | null;
    land_size_sq_metres?: number | null;
    floor_area?: string | null;
    avm_last_updated_date?: string | null;
    tracked_relationship_type?: string | null;
    property_report?: string | null;
  };
}

interface PropertyPageTrackingDataAgentsContext {
  schema: string;
  data: {
    agents: ({
      agent_id?: string | null;
      agency_id: string;
    } | null)[];
  };
}

interface PropertyPageContexts {
  property?: PropertyPageTrackingDataPropertyContext | PropertyPageTrackingDataPropertyContextV2;
  agents?: PropertyPageTrackingDataAgentsContext;
}

export const trackPropertyPageView = (tracking: PropertyPageTracking, user: User) => {
  const { pageData, useUserContext, propertyContext, agentsContext } = tracking;

  const contexts: PropertyPageContexts = { property: propertyContext };

  if (agentsContext) contexts.agents = agentsContext;

  const trackingData: DataGetter[] = [
    getPageData(deepOmitTypeName(pageData)),
    getCampaignData(),
    () => objectRemoveEmptyDeep(deepOmitTypeName(contexts)),
  ];

  if (useUserContext) {
    trackingData.push(getPcaUserData(user));
  }

  trackView(trackingData);
};
